// src/config/seo.js
export const SEO_CONFIG = {
  // Agent Information
  AGENT_NAME: "Truc Doan",
  AGENT_EMAIL: "doanestate@gmail.com",
  AGENT_PHONE: "+1-818-818-0989",
  
  // Business Address
  STREET_ADDRESS: "Westminster",
  CITY: "Westminster",
  STATE: "CA",
  ZIP_CODE: "92683",
  COUNTRY: "US",
  
  // Geographic Coordinates (Westminster, CA)
  LATITUDE: "33.7514",
  LONGITUDE: "-117.9939",
  
  // Domain & URLs
  DOMAIN: "https://trucdoan.com",
  
  // Social Media
  FACEBOOK_URL: "",
  TWITTER_HANDLE: "",
  LINKEDIN_URL: "",
  
  // Images
  OG_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/Make_this_a_professional_headshot_2k_delpmaspu.png",
  TWITTER_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/Make_this_a_professional_headshot_2k_delpmaspu.png",
  LOGO_URL: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/Make_this_a_professional_headshot_2k_delpmaspu.png"
};